import { registerSW } from 'virtual:pwa-register';

import { offerUpdate } from './installState';

/**
 * Registra o service worker do `vite-plugin-pwa` (Workbox). Com versão nova baixada, não
 * troca sozinho — recarregar no meio de um cadastro perderia o que não foi salvo —:
 * avisa (`UpdatePrompt`) e troca no "Atualizar". Só no build: no `pnpm dev` não há
 * service worker, e nos testes este arquivo não é importado.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;

  const update = registerSW({
    onNeedRefresh: () => offerUpdate(() => update(true)),
  });
}
